import { render, staticRenderFns } from "./SickDaysView.vue?vue&type=template&id=9841dc20&scoped=true"
import script from "./SickDaysView.vue?vue&type=script&lang=js"
export * from "./SickDaysView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9841dc20",
  null
  
)

export default component.exports